/** Public URLs for App Store Connect (privacy, support) and in-app links. */
export const APP_HOSTING_ORIGIN = "https://bobquiz-272a7.web.app";

export const PRIVACY_POLICY_PATH = "/privacy";
export const SUPPORT_PATH = "/support";

export const PRIVACY_POLICY_URL = `${APP_HOSTING_ORIGIN}${PRIVACY_POLICY_PATH}`;
export const SUPPORT_URL = `${APP_HOSTING_ORIGIN}${SUPPORT_PATH}`;

/** Replace when the player app is live on the App Store. */
export const APP_STORE_PLAYER_APP_URL = "";
